import request from '@/utils/request'

// 行业动态列表(首页)
export function industryNoAuthList(query) {
    return request({
        url: '/petroleum/industry/noAuth/list',
        method: 'get',
        params: query
    })
}

// 行业动态列表
export function industryList(query) {
    return request({
        url: '/petroleum/industry/newsList',
        method: 'get',
        params: query
    })
}

// 行业动态详情
export function industryDetail(id) {
    return request({
        url: `/petroleum/industry/news/${id}`,
        method: 'get',
    })
}

// 价格列表(首页)
export function priceNoAuthList(query) {
    return request({
        url: '/petroleum/metatron/price/noAuth/list',
        method: 'get',
        params: query
    })
}

// 价格列表
export function priceList(query) {
    return request({
        url: '/petroleum/metatron/price/priceDatabaseList',
        method: 'get',
        params: query
    })
}

// 价格详情
export function priceDetail(query) {
    return request({
        url: '/petroleum/metatron/price/detailsPriceDatabaseList',
        method: 'get',
        params: query
    })
}

// 库存列表(首页)
export function stockNoAuthList(query) {
    return request({
        url: '/petroleum/metatron/stock/noAuth/stockList',
        method: 'get',
        params: query
    })
}

// 库存列表
export function stockList(query) {
    return request({
        url: '/petroleum/metatron/stock/finishedProductStockList',
        method: 'get',
        params: query
    })
}

// 库存详情
export function stockDetail(query) {
    return request({
        url: '/petroleum/metatron/stock/detailsFinishedProductStockList',
        method: 'get',
        params: query
    })
}

// 研究报告列表(首页无权限)
export function reportNoAuthList(query) {
    return request({
        url: '/petroleum/report/noAuth/list',
        method: 'get',
        params: query
    })
}

// 研究报告列表
export function reportList(query) {
    return request({
        url: '/petroleum/report/reportList',
        method: 'get',
        params: query
    })
}

// 研究报告详情
export function reportDetail(id) {
    return request({
        url: `/petroleum/report/boardInfo/${id}`,
        method: 'get',
    })
}

// 技术及标准列表
export function standardList(query) {
    return request({
        url: `/petroleum/report/standardList`,
        method: 'get',
        params:query
    })
}

// 技术及标准详情
export function standardDetail(id) {
    return request({
        url: `/petroleum/report/technicalInfo/${id}`,
        method: 'get',
    })
}

// 原油产量列表(首页无权限)
export function yieldNoAuthList(query) {
    return request({
        url: '/petroleum/metatron/yield/noAuth/yieldList',
        method: 'get',
        params: query
    })
}

// 原油产量列表
export function yieldList(query) {
    return request({
        url: '/petroleum/metatron/yield/crudeYieldList',
        method: 'get',
        params: query
    })
}

// 原油产量详情
export function yieldDetail(query) {
    return request({
        url: '/petroleum/metatron/yield/detailsCrudeYieldList',
        method: 'get',
        params: query
    })
}

// 原油进出口量列表(首页无权限)
export function exitNoAuthList(query) {
    return request({
        url: '/petroleum/metatron/exit/noAuth/exitList',
        method: 'get',
        params: query
    })
}

// 原油进出口量列表
export function exitList(query) {
    return request({
        url: '/petroleum/metatron/exit/crudeExitList',
        method: 'get',
        params: query
    })
}

// 原油进出口量详情
export function exitDetail(query) {
    return request({
        url: '/petroleum/metatron/exit/detailsCrudeExitList',
        method: 'get',
        params: query
    })
}

// 炼油厂开工率列表(首页无权限)
export function rateNoAuthList(query) {
    return request({
        url: '/petroleum/metatron/rate/noAuth/rateList',
        method: 'get',
        params: query
    })
}

// 炼油厂开工率列表
export function rateList(query) {
    return request({
        url: '/petroleum/metatron/rate/refineList',
        method: 'get',
        params: query
    })
}

// 炼油厂开工率详情
export function rateDetail(query) {
    return request({
        url: '/petroleum/metatron/rate/detailsRefineList',
        method: 'get',
        params: query
    })
}

//持仓列表
export function changeList(query) {
    return request({
        url: '/petroleum/metatron/price/positionList',
        method: 'get',
        params: query
    })
}

//持仓详情
export function changeDetail(query) {
    return request({
        url: '/petroleum/metatron/price/detailsPositionList',
        method: 'get',
        params: query
    })
}

// 美元指数列表
export function dollarList(query) {
    return request({
        url: '/petroleum/metatron/price/dollarIndexList',
        method: 'get',
        params: query
    })
}

// 美元指数详情
export function dollarDetail(query) {
    return request({
        url: '/petroleum/metatron/price/detailsDollarIndexList',
        method: 'get',
        params: query
    })
}

// 全球供需平衡列表
export function balanceList(query) {
    return request({
        url: '/petroleum/report/reportSupplyList',
        method: 'get',
        params: query
    })
}

// 全球供需平衡详情
export function balanceDetail(id) {
    return request({
        url: `/petroleum/report/boardSupplyInfo/${id}`,
        method: 'get',
    })
}

// 价差列表
export function differenceList(query) {
    return request({
        url: '/petroleum/metatron/price/disintegrateList',
        method: 'get',
        params: query
    })
}

// 价差详情
export function differenceDetail(query) {
    return request({
        url: `/petroleum/metatron/price/detailsDisintegrateList`,
        method: 'get',
        params:query
    })
}

// 产业链(首页无权限)
export function chainList(query) {
    return request({
        url: '/petroleum/metatron/chain/noAuth/chainPrice',
        method: 'get',
        params: query
    })
}

// 折线图
export function priceDetailData(query) {
    return request({
        url: `/petroleum/metatron/detail/lineChart`,
        method: 'get',
        params:query
    })
}
